module.exports = __webpack_public_path__ + "static/media/bc_cover.237da035.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd552/bc_cover.png
// module id = 182
// module chunks = 0